import { useEffect } from "react";

/**
 * Mark the current page as noindex while mounted, and restore the
 * previous value (or remove the tag entirely if it didn't exist) when
 * the user navigates away.
 *
 * Used on routes that exist for app utility (auth, internal search,
 * dynamic place-ID detail pages) and have no unique evergreen content
 * worth indexing. Each /park/{place_id} for instance maps 1:1 to a
 * Google Maps listing, so indexing it ourselves only creates duplicate
 * SERP entries that compete with the canonical city + category landing
 * pages.
 *
 * The hook intentionally only manipulates the `<meta name="robots">`
 * tag; canonical/og/title etc. stay as the page set them so social
 * shares still render nicely.
 */
export function useNoIndex(enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    let el = document.querySelector('meta[name="robots"]');
    const created = !el;
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    const prev = el.getAttribute("content");
    el.setAttribute("content", "noindex, follow");
    return () => {
      if (created) {
        el.parentNode && el.parentNode.removeChild(el);
      } else if (prev !== null) {
        el.setAttribute("content", prev);
      }
    };
  }, [enabled]);
}
